window.themeObject = {};

document.addEventListener('DOMContentLoaded', () => {
    window.themeObject = {
        // Selectors
        // TODO: Move these to the "selectors" object below
        filterBtn: document.querySelector('toggle-element-class[data-options=\'{"toggleClass": "modal-is-open"}\']'),
        productRelatedSection: document.querySelector('.product-related'),

        // Selectors
        selectors: {
            
        },
        
        // Methods
    };
    // console.log('themeObject initialized:', window.themeObject);
});
